
const news = [
  {
    name: "Recruitment Notification: EDII-Anna Business Incubation Research Foundation, UCE, BIT Campus, Tiruchirappalli 620 024 ",
    link: "http://www.aubit.edu.in/pdf/EDII%20ABIRF%20Recuritment%20Notification.pdf",
    isNew: true
  },
  {
    name: "  Congratulation to our Alumnus Mr. M.Muruganantham for scoring All India Ranking -119 in UPSC 2019",
    link: "http://www.aubit.edu.in/pdf/news/muruganatham.pdf",
    isNew: true
  }
];



const events = [
  {
    name: "Online One Week Faculty Development Programme on Remote Sensing and GIS Applications in Sustainable Environmental Management (10.08.2020 to 14.08.20204",
    link: "http://www.aubit.edu.in/pdf/civil/poster.pdf",
    isNew: true
  },
  {
    name: "Two week Online Faculty Development Programme on Python program (september 07 - 08 th 2020)",
    link: "http://www.aubit.edu.in/pdf/Python%20Programming.pdf",
    isNew: true
  },
  {
    name: "Academic Schedule for Aug 2020 -Nov 2020(ODD Semester)",
    link: "http://www.aubit.edu.in/pdf/news/Circular%20-%20Copy.pdf",
    isNew: true
  },
  {
    name: "National Social Awareness Programme on Blood Donation Importance During Covid'19",
    link: "http://www.aubit.edu.in/pdf/eee/nsa.jpg",
    isNew: true
  }
];



const links = [
  {
    name: "NIFR Overall",
    link: "http://www.aubit.edu.in/pdf/UNIVERSITY%20COLLEGE%20OF%20ENGINEERING,%20BIT%20CAMPUS%20TIRUCHIRAPPALLI20200119-%20Overall.pdf",
    isNew: true
  },
  {
    name: "NIRF Engineering",
    link: "http://www.aubit.edu.in/pdf/UNIVERSITY%20COLLEGE%20OF%20ENGINEERING,%20BIT%20CAMPUS%20TIRUCHIRAPPALLI20200119-Engineering.pdf",
    isNew: false
  },
  {
    name: "Student Feedback Form",
    link: 'https://docs.google.com/forms/d/e/1FAIpQLSdbl51YuIYFMbqOi_8W0RKfhYKEE-CMnrB_9NkOrjZb5i4quA/viewform',
    isNew: true
  }
];


export { news, events, links }
